'use es6';

import createAction from 'flux-actions/createAction';
import { FETCHED_VIDEO_MAP, RECEIVED_VIDEO_MAP, REQUESTED_VIDEO_MAP, REQUESTED_VIDEO_MAP_FAILED } from './ActionTypes';
export const requestVideoMap = createAction(REQUESTED_VIDEO_MAP);
export const receiveVideoMap = createAction(RECEIVED_VIDEO_MAP, videoMap => ({
  videoMap
}));
export const requestedVideoMapFailed = createAction(REQUESTED_VIDEO_MAP_FAILED, error => ({
  error
}));
export const fetchVideos = createAction(FETCHED_VIDEO_MAP, ({
  contentPageId
}) => ({
  contentPageId
}));